module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.group) ? _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [(_vm.showGeneralPart) ? [_c('div', {
    staticClass: "form-group",
    class: {
      "has-error": _vm.modalErrors["name"]
    }
  }, [_c('label', {
    staticClass: "col-sm-2",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v(_vm._s(_vm.$t("groups.createModal.fields.name.label")))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    ref: "inputName",
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.$t("groups.createModal.fields.name.placeholder"),
      "name": "inputName"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group",
    class: {
      "has-error": _vm.modalErrors["typeGroup"]
    }
  }, [_c('label', {
    staticClass: "col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t("groups.createModal.fields.type.label")))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeGroup),
      expression: "typeGroup"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeGroup = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": -1
    }
  }, [_vm._v(_vm._s(_vm.$t("groups.createModal.fields.type.placeholder")))]), _vm._l((_vm.allTypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type
      }
    }, [_vm._v(_vm._s(_vm.$t("groups.types." + type)) + "  ")])
  })], 2)])])] : _vm._e(), (_vm.showPagePart) ? [_c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("Le page est actuellement disponible à l'adresse suivante : "), _c('a', {
    attrs: {
      "href": 'https://groopus.com/' + _vm.group.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s('https://groopus.com/' + _vm.group.url))])]), _vm._m(0), _c('div', {
    staticClass: "form-group",
    class: {
      "has-error": _vm.urlIsNotFree
    }
  }, [_c('label', {
    staticClass: "col-sm-2",
    attrs: {
      "for": "url"
    }
  }, [_vm._v(_vm._s(_vm.$t("groups.createModal.fields.publicUrl.label")))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("https://groopus.com/")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicUrlOrCalculated),
      expression: "publicUrlOrCalculated"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "url"
    },
    domProps: {
      "value": (_vm.publicUrlOrCalculated)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.publicUrlOrCalculated = $event.target.value
      }
    }
  })]), (_vm.urlIsNotFree !== false) ? [(_vm.urlIsNotFree == true) ? _c('span', {
    staticClass: "help-block text-danger"
  }, [_vm._v(_vm._s(_vm.$t('groups.createModal.fields.publicUrl.urlIsNotFree')))]) : (_vm.urlIsNotFree == 'RestrictedURL') ? _c('span', {
    staticClass: "help-block text-danger"
  }, [_vm._v(_vm._s(_vm.$t('groups.createModal.fields.publicUrl.restrictedUrl')))]) : _c('span', {
    staticClass: "help-block text-danger"
  }, [_vm._v(_vm._s(_vm.$t('groups.createModal.fields.publicUrl.malformedUrl')))])] : [_c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('groups.createModal.fields.publicUrl.emptyIfYouWant')))])]], 2)]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2",
    attrs: {
      "for": "groupSentence"
    }
  }, [_vm._v(_vm._s(_vm.$t("groups.createModal.fields.sentence.label")))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupSentence),
      expression: "groupSentence"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "groupSentence",
      "placeholder": _vm.$t("groups.createModal.fields.sentence.placeholder")
    },
    domProps: {
      "value": (_vm.groupSentence)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.groupSentence = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2",
    attrs: {
      "for": "groupDescription"
    }
  }, [_vm._v(_vm._s(_vm.$t("groups.createModal.fields.description.label")))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupDescription),
      expression: "groupDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6",
      "name": "groupDescription",
      "placeholder": _vm.$t("groups.createModal.fields.description.placeholder")
    },
    domProps: {
      "value": (_vm.groupDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.groupDescription = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t("groups.createModal.fields.visibility.label")))]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPrivate),
      expression: "isPrivate"
    }],
    attrs: {
      "type": "radio",
      "name": "private"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.isPrivate, false)
    },
    on: {
      "change": function($event) {
        _vm.isPrivate = false
      }
    }
  }), _vm._v(_vm._s(_vm.$t("groups.createModal.fields.checkPublic.label"))), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t("groups.createModal.fields.checkPublic.help")))])])])]), _c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPrivate),
      expression: "isPrivate"
    }],
    attrs: {
      "type": "radio",
      "name": "private"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.isPrivate, true)
    },
    on: {
      "change": function($event) {
        _vm.isPrivate = true
      }
    }
  }), _vm._v(_vm._s(_vm.$t("groups.createModal.fields.checkPrivate.label"))), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t("groups.createModal.fields.checkPrivate.help")))])])])])])] : _vm._e()], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("Toutes les informations (conversations, les événements, les présences, les fichiers) sont toujours privées à un groupe et non accessibles aux autres utilisateurs de GroopUs. Mais chaque groupe possède une page sur laquelle vous pouvez décider de mettre les dates de vos événements, des photos, des fichiers, ... afin de promouvoir votre groupe (comme par exemple "), _c('a', {
    attrs: {
      "href": "https://groopus.com/danstoncuivre",
      "target": "_blank"
    }
  }, [_vm._v("https://groopus.com/danstoncuivre")]), _vm._v("). Choisissez ici si vous voulez que cette page soit visible pour tout le monde ou uniquement les membres de votre groupe.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a6dc35c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupManagement/GroupEditor.vue
// module id = 992
// module chunks = 1 4